import { useReducer } from 'react';
import { PerformanceResultSortingField, SortingOrder, type PerformanceResultSortingRule } from '@/apolloClient.types';
import { SortingOrder as TableSortingOrder } from '@/components/common/Table/types';
import type { SortOrder as TableSortOrderValue } from '@/components/common/Table/types';

type SortRule = PerformanceResultSortingRule & { orderValue: TableSortOrderValue | undefined };

export interface State {
    page: number;
    pageSize: number;
    sort: SortRule;
}

export interface SetPageAction {
    type: 'SET_PAGE';
    page: number;
}

export interface SetPageSizeAction {
    type: 'SET_PAGE_SIZE';
    pageSize: number;
}

export interface SetSortAction {
    type: 'setSort';
    sortBy: SortRule;
}

export type Action = SetPageAction | SetPageSizeAction | SetSortAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'SET_PAGE':
            return { ...state, page: action.page };

        case 'SET_PAGE_SIZE':
            // Reset to page 1 when page size changes
            return { ...state, page: 1, pageSize: action.pageSize };

        case 'setSort':
            // Reset to page 1 when sort changes
            return { ...state, page: 1, sort: action.sortBy };

        default:
            return state;
    }
};

export const pageSizeOptions = [10, 25, 50, 100];

const initialState: State = {
    page: 1,
    pageSize: 10,
    sort: {
        field: PerformanceResultSortingField.CompletionDate,
        order: SortingOrder.Asc,
        orderValue: TableSortingOrder.Asc,
    },
};

const useListReducer = () => useReducer(reducer, initialState);

export default useListReducer;
